module.exports = __webpack_public_path__ + "img/37Nixon.deb83c00.png";